import React from "react";
import ContactForm from "../Components/ContactForm/ContactForm";
import { Phone, Envelope } from "react-bootstrap-icons";
import "./Home.css";
import Header from "../Images/Header.jpg";

export default function Entertainment() {
  return (
    <div className="Home">
      <div className="lander">
        <div className="body">
          {/* <h1 className="main">Helmut Fricker</h1> */}

          <div className="info">
            <h2 className="">World Class Musician and Entertainer</h2>
            {/* <Header /> */}
            <img src={Header} alt="Header" />
            <p className="text">
              Available for public and private performances. You can see
              Helmut's public performances listed below including my appearances
              on the Beaver Creek Plaza throughout the winter. More details
              below.
              <br />
              <span className="strong">
                Just listen for the famous Helmut Fricker yodel!
              </span>
            </p>
            <hr className="line" />
            <h2 className="title">Public Performances</h2>
            <div className="performanceList">
              <h3 className="title">Summer 2026 on the Plaza at Beaver Creek:</h3>
              <h5>Located at the Northface tent at the top of the escalator by the Vilar Center </h5>
              <br/>
{/* Upload everything in the build folder, but not the build folder itself to s3 and then do a cloudfront invaldiation */}
              <h3>
                <h3 class="date"> Every Monday, Tuesday and Wednesday from 1pm - 3pm, Saturdays from 12pm - 2:30pm</h3>
                <h4 className="text">June 15th - September 26th</h4>
                <h4>Note: There are no performances on July 4th and August 1st. Tuesday performances will end after August 4th. There will be no Saturday shows September 5th, 12th and 19th</h4>
                
                <br />
              </h3>
              
              <h3 className="title">Beaver Creek Oktoberfest:</h3>

              <h3>
                <h3 class="date"> September 5, 2026</h3>
                <h4>1pm - 2pm and 4pm - 5pm</h4>
                <br />
                <h3 class="date"> September 6, 2026</h3>
                <h4>1:30pm - 2:30pm</h4>
                <br />
                
              </h3>

              <h3 className="title">Eagle Chamber & Umbrella Roofing Biztoberfest:</h3>
              <h5>Brush Creek Pavillion in Eagle Ranch, Eagle, CO</h5>
                <h3>
                <h3 class="date"> September 9, 2026</h3>
                <h4>4pm-7pm</h4>
              </h3>

              <h3 className="title">Vail Oktoberfest: Lionshead</h3>

              <h3>
                <h3 class="date"> September 11, 2026</h3>
                <h4>Main Stage: 12:00pm - 1:15pm and 5:30pm - 6:30pm</h4>
                <br />
                <h3 class="date"> September 12, 2026</h3>
                <h4>Main Stage: 1:45pm - 3pm</h4>
                <br />
                <h3 class="date"> September 13, 2026</h3>
                <h4>Main Stage: 12pm - 1pm</h4>
                
              </h3>

              <h3 className="title">Vail Oktoberfest: Vail Village</h3>

              <h3>
                <h3 class="date"> September 18, 2026</h3>
                <h4>Main Stage: 1:45pm - 3pm</h4>
                <br />
                <h3 class="date"> September 19, 2026</h3>
                <h4>Main Stage: 12pm - 1pm and 6pm - 7pm</h4>
                <br />
                <h3 class="date"> September 20, 2026</h3>
                <h4>Main Stage: 3:15pm-4:15pm</h4>
                
              </h3>

              {/* <h3 className="title">Sarah's Lounge at the Christiana Lodge in Vail:</h3>
              <h3 class="date">
                Join Helmut every Friday Night from 4:30 - 6:30 throughout the Vail ski season                
              </h3>

              <h4 className="text">Starting December 12, 2025</h4>
              <h4>Extra Dates Added: April 3rd & 10th 2026</h4> */}
              
            </div>


            <hr className="line" />
            <h2 className="title">Performance Inquiries</h2>
            <h4 className="text subtitle">
              Contact Helmut directly for pricing and schedule
            </h4>
            <p>
              <Phone /> (970) 471-2779
            </p>
            <p>
              <Envelope /> helmutfricker@gmail.com
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}
